export const apiUrl = '/v1'
// export const apiUrl = 'http://localhost:3341'
